import { SentryEvent } from "./types"

export const SESSION_EXPIRED_BREADCRUMB = "Session expired, logging the user out:"

const isAfterSessionExpired = (error: SentryEvent): boolean => {
  const breadcrumbs = error?.breadcrumbs || []
  const noBreadcrumbs = !breadcrumbs?.length

  if (noBreadcrumbs) return false

  return breadcrumbs.some(breadcrumb => breadcrumb?.message?.includes(SESSION_EXPIRED_BREADCRUMB))
}

// For now this is handled only 422 errors, but the logic can be replicated for other know and safe to ignore issues.
// 422 errors occur due to invalid CSRF tokens.
// This situation might arise if a tab remains open for an extended period, and our idle monitor fails to kill the session.
// The error recovery process for this issue is managed in `authMiddleware.ts`, so there is no need to report it to Sentry.
// If recovery fails, we report to Sentry in CsrfTokenErrorPage
const isSafeToIgnore = (error: SentryEvent): boolean => {
  return !!error?.tags?.safeToIgnore
}

export const shouldIgnoreError = (error: SentryEvent): boolean => {
  return isSafeToIgnore(error) || isAfterSessionExpired(error)
}
